import { loaderConstants } from '../constants'

export const loader = async (dispatch, flag) => {
    let payload = {type: loaderConstants.ACTIVE}
    if(!flag) 
        payload = {type: loaderConstants.INACTIVE}
    await dispatch(payload)
}